import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    resetProcessError
} from "../../../actions";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';


function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class errorDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open:false
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.open !== this.state.open){
            this.setState({
                open: nextProps.open
            })
        }
    }
    
    handleOK = () =>{
        this.setState({ open: false });
        if(this.props.afterCloseFunc){
            this.props.afterCloseFunc()
        }
        else{
            this.props.dispatch(resetProcessError());
        }

    };

    render() {
        const {text, title} = this.props;
        return (
            <Dialog
                open={this.state.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    {!(text) ?
                    <DialogContentText id="alert-dialog-slide-description">
                        処理中に不明なエラーが発生しました<br/>
                        管理者へご連絡下さい
                    </DialogContentText>
                    :
                    <DialogContentText id="alert-dialog-slide-description">
                        {text}
                    </DialogContentText>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleOK} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
errorDialog.propTypes = {
    open:PropTypes.bool
,   text:PropTypes.object
,   title:PropTypes.string
,   afterCloseFunc:PropTypes.func
};
errorDialog.defaultProps = {
    open:false
,   title:'エラー'
};
function mapStateToProps() {return {};}
export default connect(mapStateToProps)(errorDialog);


// WEBPACK FOOTER //
// ./src/common/components/dialog/error-dialog.js